/* jshint esversion: 6 */
import React from 'react';
import SocialPanelModule from 'app/mixins/SocialPanelModule.js';
import ErrorModule from 'app/mixins/ErrorModule.jsx';
import { Link } from 'react-router-dom';

class FacebookOptions extends React.Component {
    render() {
        let currentPanel = null,
            optionFields = null,
            visibleSettings = null,
            postTitle = (parseInt(this.props.getParamValue('postTitle'), 10)) ? true : false,
            postBody = (parseInt(this.props.getParamValue('postBody'), 10)) ? true : false,
            postUrl = (parseInt(this.props.getParamValue('postUrl'), 10)) ? true : false,
            prefixSpace = (parseInt(this.props.getParamValue('prefixSpace'), 10)) ? true : false,
            postfixSpace = (parseInt(this.props.getParamValue('postfixSpace'), 10)) ? true : false,
            socialStats = (parseInt(this.props.getParamValue('socialStats'), 10)) ? true : false,
            postImages = (parseInt(this.props.getParamValue('postImages'), 10)) ? true : false,
            includeSummaryTitle = (parseInt(this.props.getParamValue('includeSummaryTitle'), 10)) ? true : false,
            includeSummaryBody = (parseInt(this.props.getParamValue('includeSummaryBody'), 10)) ? true : false,
            constants = this.props.app.config.constants,
            postStyles = [
                {value: constants.POST_SHARED, label: 'Shared Link'},
                {value: constants.POST_TEXT, label: 'Status Update'}
            ],
            inputSourceChooser = null;

        if (this.props.activePanel !== 'advanced') {
            let visibleFields = null;

            switch (parseInt(this.props.getParamValue('postStyle'), 10)) {
                case constants.POST_TEXT:
                    optionFields = (
                        <div>
                            {this.props.getPostTitle(postTitle)}
                            {this.props.getPostBody(postBody)}
                            {this.props.getPostUrl(postUrl)}
                            {this.props.getPostPhoto(postImages)}
                        </div>
                    );
                    break;

                case constants.POST_SHARED:
                default:
                    optionFields = (
                        <div>
                            {this.props.getIncludeSummaryTitle(includeSummaryTitle)}
                            {this.props.getIncludeSummaryBody(includeSummaryBody)}
                        </div>
                    );
                    break;
            }

            if (this.props.hasInputOverrides) {
                if (this.props.user.detail.routeViewType === this.props.app.config.constants.ROUTE_VIEW_SIMPLE) {
                    visibleSettings = this.props.generateInputOverrideLink();
                } else {
                    visibleSettings = (
                        <div>
                            {this.props.generateInputOverrideWarning()}
                            {this.props.getPostStyles.apply(this, [postStyles])}
                            {optionFields}
                        </div>
                    )
                }
                if (this.props.fieldMapping.match("output") &&
                    this.props.hasInputOverrides &&
                    this.props.socialOverrides !== undefined &&
                    this.props.socialOverrides &&
                    this.props.socialOverrides.postStyle !== undefined &&
                    this.props.socialOverrides.postStyle !== constants.SOC_OVRD_STYLE_LINK) {
                    inputSourceChooser = this.props.getInputSourceFields();
                }
            } else {
                visibleSettings = (
                    <div>
                        {this.props.getPostStyles.apply(this, [postStyles])}
                        {optionFields}
                    </div>
                );
            }

            currentPanel = (
                <div>
                    {visibleSettings}
                    {inputSourceChooser}
                    {this.props.getPrefixText(prefixSpace)}
                    {this.props.getPostfixText(postfixSpace)}
                    {this.props.getActiveToggle()}
                    {this.props.getDeleteButton()}
                </div>
            );
        } else {
            currentPanel = (
                <div>
                    {this.props.getSocialStats(socialStats)}
                </div>
            );
        }

        return this.props.getPanelOutput(currentPanel);
    }

};

export default SocialPanelModule(FacebookOptions);
